import { menuController } from '@ionic/core/components';

export class CareMapDrawerHelper {
    open = () => {
        menuController.open('content-drawer');
    };

    close = () => {
        menuController.close();
    };

    closeAndExecute = (fn: () => void) => {
        this.close();
        setTimeout(fn, 350);
    };
};
